import { Text, Box } from '@chakra-ui/react'
import { DateTime } from 'luxon'

const CustomTooltip = (props) => {
  const { active, payload } = props
  if (active) {
    const currData = payload && payload.length ? payload[0].payload : null
    return (
      <Box boxShadow="dark-lg" p={1} rounded="md" bg="white">
        <Text fontSize="sm">
          {' '}
          Date:{' '}
          <strong>
            {currData
              ? DateTime.fromSeconds(currData.date).toFormat('yyyy/LL/dd')
              : ' -- '}
          </strong>
        </Text>
        <Text fontSize="sm" mt={2}>
          {' '}
          Displacement:{' '}
          <strong>{currData ? `${currData.displacement} mm` : ' -- '}</strong>
        </Text>
      </Box>
    )
  }

  return null
}

export default CustomTooltip
